import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Typography from "@mui/material/Typography";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SimpleYesNoDialog({
  title,
  message,
  onYes,
  show,
  setShow,
}) {
  const handleNo = () => setShow(false);

  const handleYes = () => {
    onYes();
    setShow(false); // Optional: close dialog after yes
  };

  return (
    <Dialog
      open={show}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleNo}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle id="dialog-title">
        <Typography variant="h6" component="span">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="dialog-description">
          <Typography variant="body1" color="text.secondary">
            {message}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="warning"
          onClick={handleNo}
          sx={{ minWidth: 80 }}
        >
          <Typography variant="button">No</Typography>
        </Button>
        <Button
          variant="outlined"
          color="error"
          onClick={handleYes}
          sx={{ minWidth: 80 }}
        >
          <Typography variant="button">Yes</Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
}
